import {
    IEntity, IEntityCreateOptions, IEntityHeader,
    IEntityManager, IEntityManagerFindOptions,
} from "./PA.MD.IF.Entity";
import {PAdbContext} from "../PA.Core/PAdbContext";
import * as _ from "lodash"
import {EntityTypeUtils} from "../PA.MD.Entity/EntityTypeUtils";
import {WB_EntityRow} from "../PA.Core/PAdbSchemaRows";
import {CustomerEntityManager} from "../PA.MD.Entity/CustomerEntityManager";
import {ProductEntityManager} from "../PA.MD.Entity/ProductEntityManager";
import { EnterpriseEntityManager } from "../PA.MD.Entity/EnterpriseEntityManager";

export class EntityManager
    implements
        IEntityManager
{

    private dbContext: PAdbContext
    private static dctEM: {[id:string]: IEntityManager} = {}

    constructor() {
    }

    private getDbContext(options: { dbContext?: PAdbContext }): PAdbContext {
        if (!_.isEmpty(this.dbContext))
            return this.dbContext

        let dbContext = options.dbContext
        if (_.isEmpty(dbContext))
            dbContext = new PAdbContext()
        this.dbContext = dbContext
        return this.dbContext
    }

     getEntityManager(entityRow: WB_EntityRow): IEntityManager {
        let sKey = entityRow?.cif?.ENTITY_DIMENSION
        if(sKey in EntityManager.dctEM)
            return EntityManager.dctEM[sKey]

        switch (sKey){
           case 'Customer':
               EntityManager.dctEM[sKey] = new CustomerEntityManager()
               return EntityManager.dctEM[sKey]
               break;

            case 'Product':
                EntityManager.dctEM[sKey] = new ProductEntityManager()
                return EntityManager.dctEM[sKey]
                break;

            case 'Period':

                break;
            case 'Enterprise':
                EntityManager.dctEM[sKey] = new EnterpriseEntityManager();
                return EntityManager.dctEM[sKey]
        }

        return undefined
    }


    async findEntityByType(wbEntityId: number, wbId: number, options?: IEntityManagerFindOptions): Promise<IEntity> {
        let entityType = await EntityTypeUtils.getEntityTypeRow(wbEntityId)
        if (_.isEmpty(entityType))
            throw `Unknown Entity: wbEntityId ${wbEntityId}`

        let em = this.getEntityManager(entityType)

        return await em.findEntityByType(wbEntityId, wbId, options)
    }

    async findEntitiesByType(wbEntityId: number, arrWbId: number[], options?: IEntityManagerFindOptions): Promise<IEntity[]> {

        let entityType = await EntityTypeUtils.getEntityTypeRow(wbEntityId)
        if (_.isEmpty(entityType))
            throw `Unknown Entity: wbEntityId ${wbEntityId}`

        let em = this.getEntityManager(entityType)
        return await em.findEntitiesByType(wbEntityId, arrWbId, options)
    }

    async findEntityHeader(wbEntityId: number, wbId: number, options?: IEntityManagerFindOptions): Promise<IEntityHeader> {
        let entityType = await EntityTypeUtils.getEntityTypeRow(wbEntityId)
        if (_.isEmpty(entityType))
            throw `Unknown Entity: wbEntityId ${wbEntityId}`

        let em = this.getEntityManager(entityType)
        return await em.findEntityHeader(wbEntityId, wbId, options)
    }


    async queryEntitiesByType(wbEntityId: number, condition: { [p: string]: any }): Promise<number[]> {
        let entityType = await EntityTypeUtils.getEntityTypeRow(wbEntityId)
        if (_.isEmpty(entityType))
            throw new Error(`Unknown Entity: wbEntityId ${wbEntityId}`)

        let em = this.getEntityManager(entityType)
        return await em.queryEntitiesByType(wbEntityId, condition)
    }

    async queryEntitiesByTypeEnterpriseType(wbEntityId: number, wbEntityId_Enterprise: number, condition: { [p: string]: any}): Promise<{ wbId: number; wbId_Ent: number }[]> {
        let entityType = await EntityTypeUtils.getEntityTypeRow(wbEntityId)
        if (_.isEmpty(entityType))
            throw new Error(`Unknown Entity: wbEntityId ${wbEntityId}`)

        let em = this.getEntityManager(entityType)
        return await em.queryEntitiesByTypeEnterpriseType(wbEntityId, wbEntityId_Enterprise, condition)
    }


    async findEntityByMetaType(metaType: string, metaWbId: number, wbId: number, options?: IEntityManagerFindOptions): Promise<IEntity> {
        let entityType = await EntityTypeUtils.getEntityTypeRowByMeta(metaType, metaWbId)
        if (_.isEmpty(entityType))
            throw new Error(`Unknown Entity: ${metaType} , ${metaWbId}`)

        return await this.findEntityByType(entityType.cif.WB_ENTITY_ID, wbId, options)
    }

    async findEntitiesByMetaType(metaType: string, metaWbId: number, arrWbId: number[], options?: IEntityManagerFindOptions): Promise<IEntity[]> {
        let entityType = await EntityTypeUtils.getEntityTypeRowByMeta(metaType, metaWbId)
        if (_.isEmpty(entityType))
            throw new Error(`Unknown Entity: ${metaType} , ${metaWbId}`)

        return await this.findEntitiesByType(entityType.cif.WB_ENTITY_ID, arrWbId, options)
    }

    async queryEntitiesByMetaType(metaType: string, metaWbId: number, condition: { [p: string]: any }): Promise<number[]> {

        let entityType = await EntityTypeUtils.getEntityTypeRowByMeta(metaType, metaWbId)
        if (_.isEmpty(entityType))
            throw new Error(`Unknown Entity: ${metaType} , ${metaWbId}`)

        return await this.queryEntitiesByType(entityType.cif.WB_ENTITY_ID, condition)
    }

    async checkEntityExists(wbEntityId: number, key_set: string, id_ui: string): Promise<{ wbId: number; wbEntityIds: number[]; entityIds: string[]; dupError?: boolean }> {
        let entityType = await EntityTypeUtils.getEntityTypeRow(wbEntityId)
        if (_.isEmpty(entityType))
            throw new Error(`Unknown Entity: wbEntityId ${wbEntityId}`)

        let em = this.getEntityManager(entityType)
        return await em.checkEntityExists(wbEntityId, key_set, id_ui)

    }

    async createEntity(wbEntityId: number, key_set: string, id_ui: string, name: string, options?: IEntityCreateOptions): Promise<IEntity> {
        let entityType = await EntityTypeUtils.getEntityTypeRow(wbEntityId)
        if (_.isEmpty(entityType))
            throw new Error(`Unknown Entity: wbEntityId ${wbEntityId}`)

        let em = this.getEntityManager(entityType)
        return await em.createEntity(wbEntityId, key_set, id_ui, name, options)

    }




}
